import { render, staticRenderFns } from "./BulmaCheckbox.vue?vue&type=template&id=7facefa1"
import script from "./BulmaCheckbox.vue?vue&type=script&lang=js"
export * from "./BulmaCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports